/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShopIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABeElEQVR4nN2UvUoDQRDHTwv1CWyMr6GlbSSZjy2OGYmQl7BPmSD4DeKDiI0WAYlB38HOoIWKgiZgo8wmR5K7S2LwCsnCcNzOzP83uzc3QTBTC1HXkbQJJF/I+o0k17YPrA3/Pmgxn88hbTJvraWKO7e9jCzvcaHAwHHxMT4gfTOtBKBIsvNbEZzgM63k9bBeZQUA1ssh8UqlMg+k7cwApG3THGTMIetnSuBL90NKK1mltLoAeUpC5MM0h04BLGcpgQe9Kmsp8KrPI91LdpieJr7BRrm8hKQnyPIKJM/Asp/P5xfNF4bhgkGsam+kVduL8jyE9NFykeU4ypu4gKWIJPdFls1EUzgtmM+evxLzSSR1qwBIjpD0LtYZDSDdNUOSm+HrklsgPfQ3QFIfDRjRLTil/T8AkJwXCuFKFOdcKYekF5kBnCvl4rFEspoZIMgofgYAkDJzcHrAw7gT1P4KgN6MSl2DM6c/uKQzEkDS6f/pPqcWzajZWT+AkjOO/RGwNQAAAABJRU5ErkJggg==)
 */
export const ShopIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M2.63 4.19A3 3 0 0 1 5.53 2H7a1 1 0 0 1 1 1v3.98a3.07 3.07 0 0 1-.3 1.35A2.97 2.97 0 0 1 4.98 10c-2 0-3.44-1.9-2.9-3.83l.55-1.98ZM10 2a1 1 0 0 0-1 1v4a3 3 0 0 0 3 3 3 3 0 0 0 3-2.97V3a1 1 0 0 0-1-1h-4ZM17 2a1 1 0 0 0-1 1v3.98a2.43 2.43 0 0 0 0 .05A2.95 2.95 0 0 0 19.02 10c2 0 3.44-1.9 2.9-3.83l-.55-1.98A3 3 0 0 0 18.47 2H17Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21 11.42V19a3 3 0 0 1-3 3h-2.75a.25.25 0 0 1-.25-.25V16a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v5.75c0 .14-.11.25-.25.25H6a3 3 0 0 1-3-3v-7.58c0-.18.2-.3.37-.24a4.46 4.46 0 0 0 4.94-1.1c.1-.12.3-.12.4 0a4.49 4.49 0 0 0 6.58 0c.1-.12.3-.12.4 0a4.45 4.45 0 0 0 4.94 1.1c.17-.07.37.06.37.24Z"
        className={colorClass}
      />
    </svg>
  );
};
